import anime from 'animejs';
import PuzzleItem from './PuzzleItem';
import eventHub from '../eventHub';
import audio from '../audio';

class Puzzle {
  constructor(container, illustration) {
    this.$el = container;
    this.puzzleItems = [];

    this.tapAudio = null;
    this.illustration = illustration;

    this.puzzleItemsHTMLElements = [...container.getElementsByClassName('puzzle__item')];
    this.puzzleItemsHTMLElements.forEach((el, index) => {
      if (index !== this.puzzleItemsHTMLElements.length - 1) {
        this.puzzleItems.push(new PuzzleItem(el));
      } else {
        this.emptyItem = new PuzzleItem(el);
      }
    });
  }

  setBg() {
    this.puzzleItemsHTMLElements.forEach((el) => {
      el.querySelector('.c-puzzle-picture').style.backgroundImage = `url(${this.illustration})`;
    });
  }

  addEvents() {
    this.clickHandler = (index) => {
      if (this.checkMove(index)) {
        this.tapAudio = audio.get('tap');
        this.tapAudio.ref.play();
        this.swap(index - 1);

        if (this.finish()) this.win();
      }
    };
    eventHub.$on('clickPuzzleItem', this.clickHandler);
  }

  resize() {
    this.puzzleItems.forEach((item) => item.resize());
  }

  start() {
    this.emptyItem.hide();
    this.shuffleItems();
    this.addEvents();
    this.puzzleItems.forEach((item) => item.addEvents());
  }

  shuffleItems() {
    for (let i = 0; i < 75; i += 1) {
      let index = -1;
      const rand = Math.round((Math.random() * 100)) % 4;

      switch (true) { // eslint-disable-line
        case rand === 0:
          index = this.up(this.emptyItem.left, this.emptyItem.top);
          break;

        case rand === 1:
          index = this.down(this.emptyItem.left, this.emptyItem.top);
          break;

        case rand === 2:
          index = this.left(this.emptyItem.left, this.emptyItem.top);
          break;

        case rand === 3:
          index = this.right(this.emptyItem.left, this.emptyItem.top);
          break;
      }

      if (index !== -1) this.shuffleSwap(index);
    }

    this.puzzleItems.forEach((item) => item.resize());
  }

  reset() {
    this.$el.classList.remove('in-game');
    this.emptyItem.reset();
    this.puzzleItems.forEach((item) => item.reset());
    this.emptyItem.show();
    this.removeEvents();
  }

  up(x, y) {
    if (y === 0) return -1;
    return this.puzzleItems.findIndex((item) => item.top + 1 === y && item.left === x);
  }

  down(x, y) {
    if (y === 3) return -1;
    return this.puzzleItems.findIndex((item) => item.top - 1 === y && item.left === x);
  }

  left(x, y) {
    if (x === 0) return -1;
    return this.puzzleItems.findIndex((item) => item.left + 1 === x && item.top === y);
  }

  right(x, y) {
    if (x === 3) return -1;
    return this.puzzleItems.findIndex((item) => item.left - 1 === x && item.top === y);
  }

  checkMove(position) {
    return this.up(this.emptyItem.left, this.emptyItem.top) === (position - 1)
      || this.down(this.emptyItem.left, this.emptyItem.top) === (position - 1)
      || this.left(this.emptyItem.left, this.emptyItem.top) === (position - 1)
      || this.right(this.emptyItem.left, this.emptyItem.top) === (position - 1);
  }

  swap(index) {
    const temp = {
      x: this.puzzleItems[index].left,
      y: this.puzzleItems[index].top,
      index: this.puzzleItems[index].currentIndex,
    };

    this.puzzleItems[index].position = {
      x: this.emptyItem.left,
      y: this.emptyItem.top,
      index: this.emptyItem.currentIndex,
    };

    this.emptyItem.position = temp;
  }

  shuffleSwap(index) {
    const temp = {
      x: this.puzzleItems[index].left,
      y: this.puzzleItems[index].top,
      index: this.puzzleItems[index].currentIndex,
    };

    this.puzzleItems[index].left = this.emptyItem.left;
    this.puzzleItems[index].top = this.emptyItem.top;
    this.puzzleItems[index].currentIndex = this.emptyItem.currentIndex;

    this.emptyItem.position = temp;
  }

  finish() {
    return !this.puzzleItems.some(
      (el, i) => el.left !== (i % 4) || el.top !== Math.floor(i / 4),
    );
  }

  win() {
    eventHub.$emit('game-won');
    audio.play('youwin');
    anime({
      targets: this.puzzleItemsHTMLElements,
      scale: [
        {
          value: 0.8,
          easing: 'easeOutSine',
          duration: 160,
        },
        { value: 1, easing: 'easeInOutQuad', duration: 240 },
      ],
      delay: anime.stagger(80, { grid: [4, 4], from: 'center' }),
    });
    setTimeout(() => {
      this.$el.classList.remove('in-game');
      this.emptyItem.show();
      this.removeEvents();
    }, 300);

    console.log('%c+', 'font-size: 1px; padding: 180px 320px; background: url(https://media.giphy.com/media/14xFtRMKKza7WU/source.gif); background-size: 100%; color: transparent;');
  }

  removeEvents() {
    eventHub.$off('clickPuzzleItem', this.clickHandler);
    this.puzzleItems.forEach((item) => item.removeEvents());
  }

  destroy() {
    this.removeEvents();
  }
}

export default Puzzle;
